/* Block - Customer Carousel.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from './block-customer-testimonial-carousel.scss';
import rsCarousel from '../../js/component/_carousel-team';

const carousels = Array.from(document.querySelectorAll('body:not(.wp-admin) .rs-ctc-carousel'));

rsCarousel.init(carousels);
